import { ArrowRight, Sparkles } from "lucide-react";
import React from "react";
import { DEMO_ETSY_URL } from "../demoConfig";
import { useT } from "../i18n/useT";

function resolveEtsyUrl(raw: string): string {
  const url = raw.trim();
  if (!url) return "";
  // Placeholder values — treat as unset
  if (/YOUR_LISTING|example\.com|listing\/0$/i.test(url)) return "";
  return url;
}

const ETSY_URL = resolveEtsyUrl(DEMO_ETSY_URL);

/**
 * Top demo bar — dark strip + message + pill CTA (centered).
 * Link comes from this app’s `demoConfig.ts` only (per-product).
 */
export function DemoBanner() {
  const { t } = useT();

  const cta = (
    <span className="inline-flex items-center gap-2 rounded-full bg-[#7c6bb5] hover:bg-[#6b5aa3] text-white text-sm sm:text-[15px] font-semibold px-5 py-2.5 transition-colors shadow-sm whitespace-nowrap">
      {t("demo.cta")}
      <ArrowRight size={16} strokeWidth={2.5} aria-hidden />
    </span>
  );

  return (
    <div
      className="no-print w-full text-white z-50"
      style={{ background: "#1c2420" }}
      role="status"
    >
      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-5 px-4 sm:px-6 py-3.5 sm:py-4 min-h-[56px]">
        <div className="flex items-center gap-2.5 min-w-0 text-center sm:text-left">
          <Sparkles size={18} className="shrink-0 text-white/75" aria-hidden />
          <p className="text-sm sm:text-[15px] leading-snug text-white/95 font-medium">
            {t("demo.banner")}
          </p>
        </div>

        {ETSY_URL ? (
          <a
            href={ETSY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40 rounded-full"
          >
            {cta}
          </a>
        ) : null}
      </div>
    </div>
  );
}
